import { CollectionDetailSearchCriteria } from "domain/entity/Collection/CollectionDetailSearchCriteria";
import { CollectionHeaderEntity } from "domain/entity/Collection/CollectionHeaderEntity";
import { CollectionHeaderSearchCriteria } from "domain/entity/Collection/CollectionHeaderSearchCriteria";
import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { axiosPostData } from "../axios/AxiosBasicImpl";
import collectionAxiosInstance from "../axios/collectionAxiosInstance";
import { CollectionRepository } from "./CollectionRepo";

export const CollectionRepoImpl = (): CollectionRepository => {

    const searchCollectionHdrEntities = async (searchCriteria: CollectionHeaderSearchCriteria): Promise<CollectionHeaderEntity[]> => {
        const url = '/v1/searchCollectionHdr';
        return axiosPostData(collectionAxiosInstance, url, searchCriteria).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const searchCollectionDtlEntities = async (criteria: CollectionDetailSearchCriteria): Promise<ResponseEntity> => {
        const url = '/v1/searchCollectionDtl';
        return await axiosPostData(collectionAxiosInstance, url, criteria);
    }

    const deleteCollectionHdr = async (rows: CollectionHeaderEntity[]): Promise<ResponseEntity> => {
        const url = '/v1/deleteCollectionHdr';
        return await axiosPostData(collectionAxiosInstance, url, rows);
    }

    const onReprint = async (rows: CollectionHeaderEntity[]): Promise<ResponseEntity> => {
        const url = '/v1/reprintCollectionHdr';
        return await axiosPostData(collectionAxiosInstance, url, rows);
    }

    const saveCollectionDtl = async (criteria: CollectionDetailSearchCriteria): Promise<ResponseEntity> => {
        const url = '/v1/saveCollectionDtl';
        return await axiosPostData(collectionAxiosInstance, url, criteria);
    }

    const delCollectionDtl = async (criteria: CollectionDetailSearchCriteria): Promise<ResponseEntity> => {
        const url = '/v1/delCollectionDtl';
        return await axiosPostData(collectionAxiosInstance, url, criteria);
    }

    const onleaveDtl = async (criteria: CollectionDetailSearchCriteria): Promise<ResponseEntity> => {
        const url = '/v1/leaveCollectionDtl';
        return await axiosPostData(collectionAxiosInstance, url, criteria);
    }

    const confirmCollectionHdr = async (criteria: CollectionDetailSearchCriteria): Promise<ResponseEntity> => {
        const url = '/v1/confirmCollectionHdr';
        return await axiosPostData(collectionAxiosInstance, url, criteria);
    }

    const searchDtl = async (ids: number[]): Promise<ResponseEntity> => {
        const url = '/v1/getCollectionDtl';
        return await axiosPostData(collectionAxiosInstance, url, ids);
    }
    const saveCollectionHdr = async (criteria: CollectionDetailSearchCriteria): Promise<ResponseEntity> => {
        const url = '/v1/saveCollectionHdr';
        return await axiosPostData(collectionAxiosInstance, url, criteria);
    }
    return {
        onReprint: onReprint,
        searchCollectionHdrEntities: searchCollectionHdrEntities,
        deleteCollectionHdr: deleteCollectionHdr,
        searchCollectionDtlEntities: searchCollectionDtlEntities,
        saveCollectionDtl: saveCollectionDtl,
        delCollectionDtl: delCollectionDtl,
        confirmCollectionHdr: confirmCollectionHdr,
        onleaveDtl: onleaveDtl,
        searchDtl: searchDtl,
        saveCollectionHdr: saveCollectionHdr,
    }
}